import { ReactElement } from 'react';
import { Button, Icon, Text } from '@msc-b2c/shared-components';

import styles from '../customerinformationcontainer.module.scss';

export function CustomerInformationSection({
  sectionTitleIcon,
  sectionTitle,
  sectionCtaLabel,
  sectionCtaLink,
  sectionCTAOnClick,
  children,
}: Readonly<{
  sectionTitleIcon: string;
  sectionTitle: string;
  sectionCtaLabel: string;
  sectionCtaLink?: { url?: string; valid?: boolean };
  sectionCTAOnClick: () => void;
  children?: ReactElement[];
}>) {
  return (
    <div className={styles['cmp-customer-information-container__section']}>
      <div className={styles['cmp-customer-information-container__section-header']}>
        <div className={styles['cmp-customer-information-container__section-header-title-wrapper']}>
          <Icon
            icon={sectionTitleIcon}
            styleOption="icon-medium"
          />
          <Text
            text={sectionTitle}
            styleOption="cmp-text__normal bold"
          />
        </div>

        <Button
          text={sectionCtaLabel}
          buttonLink={sectionCtaLink}
          onClick={sectionCTAOnClick}
          styleOption={'cmp-button__link'}
        />
      </div>
      {children && (
        <div className={styles['cmp-customer-information-container__section-body']}>{children}</div>
      )}
    </div>
  );
}
